import {
  FETCHING_INTEGRATIONS_REQUEST,
  FETCHING_INTEGRATIONS_SUCCEDDED,
  FETCHING_INTEGRATIONS_FAILED,
  INVALIDATE_INTEGRATIONS,
  FETCHING_INTEGRATION_SUCCEDDED,
  ACTIVATING_INTEGRATION_SUCCEDDED,
  SYNCHRONISING_INTEGRATION_SUCCEDDED,
  DEACTIVATING_INTEGRATION_REQUEST,
  DEACTIVATING_INTEGRATION_SUCCEDDED,
  DEACTIVATING_INTEGRATION_FAILED,
  INTEGRATION_AUTH_EXPIRED,
  FETCHING_INTEGRATION_CONTACTS,
  FETCHING_INTEGRATION_CONTACTS_SUCCEEDED,
  FETCHING_INTEGRATION_CONTACTS_FAILED,
  INVALIDATE_INTEGRATION_CONTACTS,
  FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST,
  FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEDDED,
  FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED,
  FETCHING_INTEGRATION_CUSTOM_FIELDS_REQUEST,
  FETCHING_INTEGRATION_CUSTOM_FIELDS_SUCCEDDED,
  FETCHING_INTEGRATION_CUSTOM_FIELDS_FAILED,
  SAVING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST,
  SAVING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED,
  SAVING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED,
  SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST,
  SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED,
  SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED,
  DELETING_INTEGRATION_CUSTOM_FIELDS_REQUEST,
  DELETING_INTEGRATION_CUSTOM_FIELDS_SUCCEEDED,
  DELETING_INTEGRATION_CUSTOM_FIELDS_FAILED,
  FETCHING_CRM_ENABLED_INTEGRATION_REQUEST,
  FETCHING_CRM_ENABLED_INTEGRATION_SUCCEEDED,
  FETCHING_CRM_ENABLED_INTEGRATION_FAILED,
  DEACTIVATING_HUBSPOT_INTEGRATION,
  DEACTIVATING_HUBSPOT_INTEGRATION_SUCCEDDED,
  DEACTIVATING_HUBSPOT_INTEGRATION_FAILED,
  FETCHING_HUBSPOT_INTEGRATION_REQUEST,
  FETCHING_HUBSPOT_INTEGRATION_REQUEST_SUCCEDDED,
  FETCHING_HUBSPOT_INTEGRATION_REQUEST_FAILED
} from "./actionTypes.jsx";
import axios from "axios";
import buildUrl from "build-url-ts";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const INTEGRATIONS_BASE_URL = `${apiUrl}/api/2.0/integrations`;
const INTEGRATIONS_BASE_URL_V2 = `${apiUrl}/api/2.1/integrations`;

export function fetchingIntegrationSuccedded(json) {
  return {
    type: FETCHING_INTEGRATION_SUCCEDDED,
    payload: json,
  };
}
export function fetchIntegrations() {
  return function (dispatch) {
    dispatch(fetchingIntegrations());

    return axios({
      method: "GET",
      url: INTEGRATIONS_BASE_URL,
    })
      .then((response) =>
        dispatch(fetchingIntegrationsSuccedded(response.data))
      )
      .catch((error) => dispatch(fetchingIntegrationsFailed(error)));
  };
}

function fetchingIntegrations() {
  return {
    type: FETCHING_INTEGRATIONS_REQUEST,
    payload: {},
  };
}

function fetchingIntegrationsSuccedded(json) {
  return {
    type: FETCHING_INTEGRATIONS_SUCCEDDED,
    payload: json,
  };
}

function fetchingIntegrationsFailed(error) {
  return {
    type: FETCHING_INTEGRATIONS_FAILED,
    payload: error,
  };
}

export function fetchHubspotIntegration() {
  return function (dispatch) {
    dispatch(fetchingHubspotIntegration());

    var url = buildUrl(INTEGRATIONS_BASE_URL, {
      path: `/hubspot`,
    });

    return axios({
      method: "GET",
      url: url
    })
    
      .then((response) =>
        dispatch(fetchingHubspotIntegrationSuccedded(response.data))
      )
      .catch((error) => dispatch(fetchingHubspotIntegrationFailed(error)));
  };
}

function fetchingHubspotIntegration() {
  return {
    type: FETCHING_HUBSPOT_INTEGRATION_REQUEST,
    payload: {},
  };
}

function fetchingHubspotIntegrationSuccedded(json) {
  return {
    type: FETCHING_HUBSPOT_INTEGRATION_REQUEST_SUCCEDDED,
    payload: json,
  };
}

function fetchingHubspotIntegrationFailed(error) {
  return {
    type: FETCHING_HUBSPOT_INTEGRATION_REQUEST_FAILED,
    payload: error,
  };
}

export function invalidateIntegrations() {
  return {
    type: INVALIDATE_INTEGRATIONS,
    payload: {},
  };
}

export function shouldFetchIntegrations(integrations) {
  let resource = integrations;

  if (!resource.items) {
    return true;
  } else if (resource.loading) {
    return false;
  } else {
    return resource.invalidated;
  }
}

export function getIntegrationForType(state, type) {
  try {
    let items = state.legacyRootReducer.settings.integrations.activated.items;

    let integration = items
      .filter((item) => {
        return item != null;
      })
      .find((item) => {
        return item.type == type;
      });

    return integration;
  } catch (e) {}

  return null;
}

export function getIntegrationForCategory(state, category) {
  try {
    let items = state.legacyRootReducer.settings.integrations.activated.items;

    let integration = items
      .filter((item) => {
        return item != null;
      })
      .find((item) => {
        return item.category.id === category;
      });

    return integration;
  } catch (e) {
    return null;
  }

}

export function activatingIntegrationSuccedded(json) {
  return {
    type: ACTIVATING_INTEGRATION_SUCCEDDED,
    payload: json,
  };
}

export function deactivatingIntegrationSuccedded(json) {
  return {
    type: DEACTIVATING_INTEGRATION_SUCCEDDED,
    payload: json,
  };
}

export function synchronisingIntegrationSuccedded(json) {
  return {
    type: SYNCHRONISING_INTEGRATION_SUCCEDDED,
    payload: json,
  };
}

export function integrationAuthExpired(json, type) {
  return {
    type: INTEGRATION_AUTH_EXPIRED,
    payload: {
      state: json,
      type: type,
    },
  };
}

export function deactivateV2Integration(type) {
  return function (dispatch) {
    dispatch(deactivatingIntegration());

    let url = buildUrl(INTEGRATIONS_BASE_URL_V2, {
      path: type,
    });

    return axios({
      method: "DELETE",
      url: url,
    })
      .then((response) => {
        dispatch(
          deactivatingIntegrationSuccedded({ type: type, data: response.data })
        );
      })
      .catch((error) => dispatch(deactivatingIntegrationFailed(error.errors)));
  };
}

export function deactivateIntegration(type) {
  return function (dispatch) {
    dispatch(deactivatingIntegration());
    let baseUrl = INTEGRATIONS_BASE_URL;

    let url = buildUrl(baseUrl, {
      path: type,
    });

    return axios({
      method: "DELETE",
      url: url,
    })
      .then((response) => {
        dispatch(
          deactivatingIntegrationSuccedded({ type: type, data: response.data })
        );
      })
      .catch((error) => dispatch(deactivatingIntegrationFailed(error.errors)));
  };
}

function deactivatingIntegration() {
  return {
    type: DEACTIVATING_INTEGRATION_REQUEST,
    payload: {},
  };
}

// function deactivatingIntegrationSuccedded(json) {
//   return {
//     type: DEACTIVATING_INTEGRATION_SUCCEDDED,
//     payload: json,
//   };
// }

function deactivatingIntegrationFailed(error) {
  return {
    type: DEACTIVATING_INTEGRATION_FAILED,
    payload: error,
  };
}

export function deactivateHubspotIntegration(id){
  return function (dispatch) {
    dispatch(deactivatingHubspotIntegration());
    let baseUrl = INTEGRATIONS_BASE_URL;

    let url = buildUrl(baseUrl, {
      path: `/hubspot/${id}`,
    });

    return axios({
      method: "DELETE",
      url: url,
    })
      .then((response) => {
        dispatch(
          deactivatingHubspotIntegrationSuccedded({ data: response.data })
        );
      })
      .catch((error) => dispatch(deactivatingHubspotIntegrationFailed(error.errors)));
  };
}

function deactivatingHubspotIntegration() {
  return {
    type: DEACTIVATING_HUBSPOT_INTEGRATION,
    payload: {},
  };
}

function deactivatingHubspotIntegrationSuccedded(json) {
  return {
    type: DEACTIVATING_HUBSPOT_INTEGRATION_SUCCEDDED,
    payload: json,
  };
}

function deactivatingHubspotIntegrationFailed(error) {
  return {
    type: DEACTIVATING_HUBSPOT_INTEGRATION_FAILED,
    payload: error,
  };
}

export function fetchIntegrationContacts(integration, query, page) {
  return function (dispatch) {
    dispatch(fetchingIntegrationContacts(integration, query));

    var params = {
      integration: integration,
      query: query,
      page: page,
    };

    var url = buildUrl(INTEGRATIONS_BASE_URL, {
      path: `/contacts`,
    });

    return axios({
      method: "GET",
      url: url,
      params: params,
    })
      .then((response) =>
        dispatch(
          fetchingIntegrationContactsSucceeded(
            integration,
            query,
            response.data
          )
        )
      )

      .catch((error) =>
        dispatch(fetchingIntegrationContactsFailed(integration, query, error))
      );
  };
}

function fetchingIntegrationContacts(integration, query) {
  return {
    type: FETCHING_INTEGRATION_CONTACTS,
    payload: {
      integration: integration,
      query: query,
    },
  };
}

function fetchingIntegrationContactsSucceeded(integration, query, json) {
  return {
    type: FETCHING_INTEGRATION_CONTACTS_SUCCEEDED,
    payload: {
      integration: integration,
      query: query,
      result: json,
    },
  };
}

function fetchingIntegrationContactsFailed(integration, query, error) {
  return {
    type: FETCHING_INTEGRATION_CONTACTS_FAILED,
    payload: {
      integration: integration,
      query: query,
      error: error,
    },
  };
}

export function invalidateIntegrationContacts() {
  return {
    type: INVALIDATE_INTEGRATION_CONTACTS,
    payload: {},
  };
}

// fetch integration opportunity fields
export function fetchOpportunityFields(id, filters) {
  return function (dispatch) {
    dispatch(fetchingOpportunityFields());

    let url = buildUrl(INTEGRATIONS_BASE_URL, {
      path: `${id}/opportunity/fields/search`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filters
    })
      .then((response) =>
        dispatch(fetchingOpportunityFieldsSuccedded(response.data))
      )
      .catch((error) => dispatch(fetchingOpportunityFieldsFailed(error)));
  };
}

function fetchingOpportunityFields() {
  return {
    type: FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST,
    payload: {},
  };
}

function fetchingOpportunityFieldsSuccedded(json) {
  return {
    type: FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEDDED,
    payload: json,
  };
}

function fetchingOpportunityFieldsFailed(error) {
  return {
    type: FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED,
    payload: error,
  };
}

// fetch integration custom fields
export function fetchCustomFields(id) {
  return function (dispatch) {
    dispatch(fetchingCustomFields());

    let url = buildUrl(INTEGRATIONS_BASE_URL, {
      path: `${id}/custom/fields`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) =>
        dispatch(fetchingCustomFieldsSuccedded(response.data))
      )
      .catch((error) => dispatch(fetchingCustomFieldsFailed(error)));
  };
}

function fetchingCustomFields() {
  return {
    type: FETCHING_INTEGRATION_CUSTOM_FIELDS_REQUEST,
    payload: {},
  };
}

function fetchingCustomFieldsSuccedded(json) {
  return {
    type: FETCHING_INTEGRATION_CUSTOM_FIELDS_SUCCEDDED,
    payload: json,
  };
}

function fetchingCustomFieldsFailed(error) {
  return {
    type: FETCHING_INTEGRATION_CUSTOM_FIELDS_FAILED,
    payload: error,
  };
}

// delete integration custom fields
export function deleteCustomFields(id, customFieldIds) {
  return function (dispatch) {
    dispatch(deletingCustomFields());

    let url = buildUrl(INTEGRATIONS_BASE_URL, {
      path: `${id}/custom/fields`,
    });

    return axios({
      method: "DELETE",
      url: url,
      data: customFieldIds,
    })
      .then((response) =>
        dispatch(deletingCustomFieldsSuccedded(response.data))
      )
      .catch((error) => dispatch(deletingCustomFieldsFailed(error)));
  };
}

function deletingCustomFields() {
  return {
    type: DELETING_INTEGRATION_CUSTOM_FIELDS_REQUEST,
    payload: {},
  };
}

function deletingCustomFieldsSuccedded(json) {
  return {
    type: DELETING_INTEGRATION_CUSTOM_FIELDS_SUCCEEDED,
    payload: json,
  };
}

function deletingCustomFieldsFailed(error) {
  return {
    type: DELETING_INTEGRATION_CUSTOM_FIELDS_FAILED,
    payload: error,
  };
}

// save opportunity fields

export function saveOpportunityFields(id, data) {
  return function (dispatch) {
    dispatch(savingOpportunityFields());

    let url = buildUrl(INTEGRATIONS_BASE_URL, {
      path: `${id}/opportunity/fields`,
    });

    return axios({
      method: "POST",
      url: url,
      data: data,
    })
      .then((response) =>
        dispatch(savingOpportunityFieldsSuccedded(response.data))
      )
      .catch((error) => dispatch(savingOpportunityFieldsFailed(error)));
  };
}

function savingOpportunityFields() {
  return {
    type: SAVING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST,
    payload: {},
  };
}

function savingOpportunityFieldsSuccedded(json) {
  return {
    type: SAVING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED,
    payload: json,
  };
}

function savingOpportunityFieldsFailed(error) {
  return {
    type: SAVING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED,
    payload: error,
  };
}

export function syncOpportunityFields(id) {
  return function (dispatch) {
    dispatch(syncingOpportunityFields());

    let url = buildUrl(INTEGRATIONS_BASE_URL, {
      path: `${id}/opportunity/fields/sync`,
    });

    return axios({
      method: "PUT",
      url: url,
    })
      .then((response) =>
        dispatch(syncingOpportunityFieldsSuccedded(response.data))
      )
      .catch((error) => dispatch(syncingOpportunityFieldsFailed(error)));
  };
}

function syncingOpportunityFields() {
  return {
    type: SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST,
    payload: {},
  };
}

function syncingOpportunityFieldsSuccedded(json) {
  return {
    type: SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED,
    payload: json,
  };
}

function syncingOpportunityFieldsFailed(error) {
  return {
    type: SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED,
    payload: error,
  };
}

export function fetchCRMEnabledIntegration() {
  return function (dispatch) {
    dispatch(fetchingCRMEnabledIntegration());

    var url = buildUrl(INTEGRATIONS_BASE_URL, {
      path: `/crm-enabled-integration`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) =>
        dispatch(fetchingCRMEnabledIntegrationSucceeded(response))
      )
      .catch((error) => dispatch(fetchingCRMEnabledIntegrationFailed(error)));
  };
}

function fetchingCRMEnabledIntegration() {
  return {
    type: FETCHING_CRM_ENABLED_INTEGRATION_REQUEST,
    payload: {},
  };
}

function fetchingCRMEnabledIntegrationSucceeded(response) {
  return {
    type: FETCHING_CRM_ENABLED_INTEGRATION_SUCCEEDED,
    payload: response,
  };
}

function fetchingCRMEnabledIntegrationFailed(error) {
  return {
    type: FETCHING_CRM_ENABLED_INTEGRATION_FAILED,
    payload: error,
  };
}
